export default {
    init() {
        this.initClientStatistic();
    },

    initClientStatistic() {

        const data = {
            labels: ['0.00', '0.00', '0.00', '0.00', '0.00', '0.00', '0.00', '0.00', '0.00', '0.00', '0.00', '0.00'],
            datasets: [{
                data: [10, 20, 30, 50, 40, 20, 10, 10, 20, 5, 14, 66],
                label: "Test1",
                backgroundColor: "#88E213",
                borderRadius: Number.MAX_VALUE,
                barPercentage: .3,
            }, {
                data: [10, 20, 10, 10, 20, 50, 55, 45, 22, 33, 45, 65],
                label: "Test2",
                backgroundColor: "#EFF2F5",
                borderRadius: Number.MAX_VALUE,
                barPercentage: .3,
            }
            ]
        };

        const config = {
            type: 'bar',
            data: data,
            options: {
                responsive: true,
                plugins: {
                    title: {
                        display: false,
                    },
                    legend: {
                        display: false,
                    }
                },
                scales: {
                    x: {
                        grid: {
                            display: false,
                            drawBorder: false,
                        },
                        ticks: {
                            font: {
                                font: 'Proxima Nova',
                                size: 10,
                                color: '#778795',
                                fontWeight: 600,
                            }
                        },
                    },
                    y: {
                        grid: {
                            display: true,
                            borderDash: [5, 10],
                            drawBorder: false,
                        },
                        ticks: {
                            font: {
                                font: 'Proxima Nova',
                                size: 10,
                                color: '#778795',
                                fontWeight: 600,
                            }
                        },
                    }
                }
            }

        };

        const myChart = new Chart(
            document.getElementById('myChart'),
            config
        );
    },
}
